var map = {
	"./b_b.png": 32,
	"./b_w.png": 33,
	"./k_b.png": 34,
	"./k_w.png": 35,
	"./n_b.png": 36,
	"./n_w.png": 37,
	"./p_b.png": 38,
	"./p_w.png": 39,
	"./q_b.png": 40,
	"./q_w.png": 41,
	"./r_b.png": 42,
	"./r_w.png": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;